import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'

// import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)
export default function createStore() {
  return new Vuex.Store({
    // plugins: [createPersistedState()],    //store 持久化插件保证 刷新时store还在(ssr没有window不兼容)
    namespaced: true,
    // 重要信息：state 必须是一个函数
    state: () => ({
      sitiInfo: {},
      newsInfo: {},
      currentLanguge: '',
      msgnum: 0,
      competitionIntroduction: {},
      articles: [],
      globalDataArray: {},
      modalStates: {
        signway: false,
        formsign: false,
        formapply: false,
        formmsg: false,
        formxieyi: false,
        formEntry: false,
        qrCode: false,
        agreementContent: '',
        noticeContent: '',
        hasAgreementUpdate: 0,
        hasNoticeUpdate: 0
      },
      currentTime: 0,
      saitiStatusCont: {
        hasChild: false,
        signup: '',
        isSignup: 0,
        hasAgreementUpdate: 0,
        hasNoticeUpdate: 0,
        mark: [],
        organizersLogo: [],
        organizers: [],
        localEndtime: '',
        localStarttime: '',
        localEndtimeStr: 0
      }
    }),
    actions,
    mutations
  })
}
